import { render, staticRenderFns } from "./homeBottom.vue?vue&type=template&id=604bdaca&scoped=true&"
import script from "./homeBottom.vue?vue&type=script&lang=js&"
export * from "./homeBottom.vue?vue&type=script&lang=js&"
import style0 from "./homeBottom.vue?vue&type=style&index=0&id=604bdaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bdaca",
  null
  
)

export default component.exports